export default "__VITE_ASSET__Cfu1SBKL__"